import { useId, useMemo } from 'react'
import type { ChangeEvent, ReactElement } from 'react'
import { useLocale, useTranslate } from '../lib/i18n-provider'

/**
 * Taalkeuze. De namen van de talen komen uit Intl.DisplayNames in de actieve
 * taal — dat is exact wat §17.8 voorschrijft en het scheelt vertaalsleutels die
 * bij iedere nieuwe taal handmatig bijgewerkt zouden moeten worden.
 */
export function LocaleSwitcher(): ReactElement {
  const t = useTranslate()
  const { locale, locales, setLocale } = useLocale()
  const selectId = useId()

  const displayNames = useMemo(
    () => new Intl.DisplayNames([locale], { type: 'language' }),
    [locale],
  )

  function handleChange(event: ChangeEvent<HTMLSelectElement>): void {
    const next = locales.find((candidate) => candidate === event.target.value)
    if (next !== undefined) {
      setLocale(next)
    }
  }

  return (
    <div className="locale-switcher">
      <label className="locale-switcher__label" htmlFor={selectId}>
        {t('common.language.label')}
      </label>
      <select
        className="locale-switcher__select"
        id={selectId}
        value={locale}
        onChange={handleChange}
      >
        {locales.map((candidate) => (
          <option key={candidate} value={candidate}>
            {displayNames.of(candidate) ?? candidate}
          </option>
        ))}
      </select>
    </div>
  )
}
